import { Injectable, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs/Subscription';
import { AuthenticationActions } from '../auth/state/authentication.actions';
import { AuthenticationSelectors } from '../auth/state/authentication.selectors';
import { FeatureFlagsService } from '../feature-flag/core/feature-flags.service';
import { ContentEditableService } from './content-editable/contenteditable.service';
import { PreviewEditTemplateActions } from '../preview-edit-template/state/preview-edit-template.actions';

/**
 * This service is a bridge between angularJS and Angular passing on events between the two.
 *
 * TODO: Refactor to just expose the store directly in angularJS (see ngVikings talk about this)
 */
@Injectable({
    providedIn: 'root' // No need to provide in AppModule, and now tree shakable
})
export class EventSharingService implements OnDestroy {
    subscription = new Subscription();

    constructor(
        private authenticationSelectors: AuthenticationSelectors,
        private router: Router,
        private featureFlagsService: FeatureFlagsService,
        private contenteditableService: ContentEditableService,
        private store: Store<any>) {
    }

    public setRoute(route: string, params: any): void {
        this.router.navigate([route], {queryParams: params});
    }

    public sessionTimeOut(): void {
        this.subscription.add(
            this.authenticationSelectors.selectIsPortalVersionChangedSelector()
                .subscribe(isPortalVersionChanged => {
                    if (!isPortalVersionChanged) {
                        this.store.dispatch(AuthenticationActions.sessionTimeout());
                    }
                }
        ));
    }


    hasPermission(flagsToCheck): boolean {
        let hasPermission = false;
        this.featureFlagsService
            .hasFlags(flagsToCheck)
            .subscribe(hasFlags => hasPermission = hasFlags);

        return hasPermission;
    }

    validateTemplateBeforeSave(updatedModel): any {
        const templateDefaultContent = {};
        Object.entries(updatedModel).map((tData) => {
            templateDefaultContent[tData[0]] = this.contenteditableService.validateTemplateBeforeSave(tData);
        });

        const templateUpdateModel = {
            updatedModel : templateDefaultContent,
            isModelUpdated: false,
            updateType: "autoCorrectAndSavingForCommunication",
            type: "",
        };
        this.store.dispatch(
            PreviewEditTemplateActions.templateUpdateModel({
                templateUpdateModel,
            })
        );

        return templateDefaultContent;
    }

    validateTemplateOnSendTest(updatedModel): boolean {
        let response: any = this.contenteditableService.validateTemplateOnBlur('', updatedModel);
        let errorMsg = 'The template contains some incorrect values. Please save the job before sending a Test Message to auto correct them.';

        if (response.listOfModels !== '') {
            this.store.dispatch(PreviewEditTemplateActions.displayDialogOnError({error: errorMsg}));
        }

        return response.listOfModels === '';
    }

    ngOnDestroy(): any {
        this.subscription.unsubscribe();
    }

}
